import { createFileRoute } from "@tanstack/react-router";
import VisitorFormPage from "@project/user/pages/community/visitor-form";

export const Route = createFileRoute("/_user/_community/visitor-form")({
  head: () => ({
    meta: [
      { title: "Visitor Feedback Form — Jivandhara Vruddhashram" },
      {
        name: "description",
        content:
          "Share visitor details, family information and feedback after your visit to Jivandhara Old Age Home.",
      },
      { property: "og:title", content: "Visitor Feedback Form — Jivandhara" },
      {
        property: "og:description",
        content: "Share visitor feedback with Jivandhara Old Age Home.",
      },
    ],
  }),
  component: VisitorFormPage,
});
